import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const RoleValidator = t.intersection([
  t.type({
    id: t.string,
    key: t.string,
    name: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    description: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export const RoleArrayValidator = t.array(
  RoleValidator
);

export type Role = t.TypeOf<typeof RoleValidator>;
export type RoleArray = t.TypeOf<typeof RoleArrayValidator>;

@Exclude()
export class RoleEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  key!: string;

  @Expose()
  name!: string;

  @Expose()
  description?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  readonly entityType = 'ROLE';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for RoleEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: Role): RoleEntity {
    return plainToInstance(RoleEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<Role> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(RoleValidator, object);
  }

  asTypeValue(): Role {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(RoleValidator, object);
  }
}
